import Cookies from 'js-cookie';
import httpClient from '../httpClient';

/**
 * Performs complete logout - clears storage, cookies, calls logout API
 * @param {Function} navigate - react-router navigate function
 */
export const performLogout = async (navigate) => {
  try {
    // Call logout API to update logout timestamp
    const token = localStorage.getItem('ids_token');
    if (token) {
      try {
        await httpClient.post('/logout', {}, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });
      } catch (error) {
        // Log error but continue with logout even if API call fails
        console.error('Error calling logout API:', error);
      }
    }
  } catch (error) {
    console.error('Error in logout:', error);
  } finally {
    // Clear all relevant localStorage items
    localStorage.removeItem('ids_token');
    localStorage.removeItem('ids_auth_level');
    localStorage.removeItem('ids_user_id');
    localStorage.removeItem('ids_user_name');
    localStorage.removeItem('ids_org_id');
    localStorage.removeItem('ids_first_time_login');
    localStorage.removeItem('ids_user_mail');
    localStorage.removeItem('ids_should_show_guide');
    localStorage.clear();

    // Clear cookies properly
    Cookies.remove('email', { path: '/' });
    Cookies.remove('password', { path: '/' });
    Cookies.remove('remember_status', { path: '/' });

    // Dispatch custom event to clear form data
    window.dispatchEvent(new CustomEvent('clearLoginForm'));

    // Navigate to the login page
    if (navigate) {
      navigate('/login');
    }
  }
};
